import React from 'react';
import { connect } from 'react-redux';

// Actions
import { setAdvancedOptions, setEditAdvancedOptions } from '../../../actions/stepsChat';

// Icons
import WhatsAppIcon from '../../../assets/icons/Advanced/WhatsAppIcon';
import WhastPROIcon from '../../../assets/icons/Advanced/WhastPROIcon';

const ButtonDesignComponent = (props) => {

    // Actions
    const { setEditAdvancedOptions, advancedOptions } = props;

    // States
    const { whatsAppIcon } = props;

    const handleSelectIcon = ( type ) => {
        setEditAdvancedOptions({
            editAdvancedOptions: true
        });
        if (type === 'whatsapp') {
            advancedOptions({
                whatsAppIcon: true
            });
        } else {
            advancedOptions({
                whatsAppIcon: false
            });
        }
    }

    const tileClass = (active) =>
        `flex cursor-pointer items-center justify-center rounded-sm py-4 transition-all duration-150 ${
            active ? 'bg-card shadow-card ring-1 ring-inset ring-primary/30' : 'hover:bg-card/60'
        }`;

    return (
        <div className="grid grid-cols-2 gap-2 rounded-[12px] border border-border bg-secondary p-2">
            <div className={ tileClass(!whatsAppIcon) } onClick={ () => handleSelectIcon('whatspro') }>
                <WhastPROIcon color={ !whatsAppIcon ? '#0DA15A' : '#9A97AE' }/>
            </div>
            <div className={ tileClass(whatsAppIcon) } onClick={ () => handleSelectIcon('whatsapp') }>
                <WhatsAppIcon color={ whatsAppIcon ? '#2ED588' : '#9A97AE' }/>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        whatsAppIcon: state.stepsChat.advancedOptions.whatsAppIcon,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setEditAdvancedOptions: (value) => dispatch(setEditAdvancedOptions(value)),
        advancedOptions: (value) => dispatch(setAdvancedOptions(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)( ButtonDesignComponent );